<template>
  <div class="key-advantages flex-box">
    <div class="title">璞华易研PLM（流程行业）的主要优势</div>
    <div class="description">专注流程行业，深耕流程行业，助力化工材料、食品日化、医药等行业研发效率腾飞</div>
    <div class="ClassicCase-content">
      <el-carousel 
        ref="carousel" 
        :height="slideHeight + 'px'" 
        trigger="click" 
        :interval="5000" 
        arrow="never" 
        indicator-position="none" 
        @change="setActiveItem"
      >
        <el-carousel-item v-for="(item, index) in carouselList"  :key="index" :name="item.name">
          <div class="carousel-box flex-box">
            <div class="content-left">
              <el-image
                class="case-img preview-shot"
                fit="contain"
                :src="item.icon"
                :preview-src-list="previewImgs"
              />
            </div>
            <div class="content-right">
              <div class="info-wrap">
                <div class="content-num">{{ item.num }}</div>
                <div class="content-name">{{ item.name }}</div>
                <div class="content-desc">{{ item.description }}</div>
                <div class="cl-list" v-if="item.contentList">
                  <div class="cl-list-item"  v-for="(subItem, sk) in item.contentList" :key="sk">
                    <div class="cl-l-i-title" v-if="subItem.title">{{ subItem.title }}：</div>
                    <div class="cl-l-i-content">{{ subItem.content }}</div>
                  </div>
                </div>
              </div>
            
            </div>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="btn-wrap">
      <img class="img1" v-lazy="btn1" alt=""  @click="clickHandle(-1)">
      <img class="img2" v-lazy="btn2" alt="" @click="clickHandle(1)">
    </div>
      
  </div>
</template>
<script>
import btn1 from '@/assets/images/btn1.png'
import btn2 from '@/assets/images/btn2.png'
import al1 from '@/assets/images/ys1-1.png'
import al2 from '@/assets/images/ys1-2.png'
import al3 from '@/assets/images/ys1-3.png'
import al4 from '@/assets/images/ys1-4.png'
import al5 from '@/assets/images/ys1-5.png'
import al6 from '@/assets/images/ys1-6.png'
import al7 from '@/assets/images/ys1-7.png'
import al8 from '@/assets/images/ys1-8.png'
import mobileCarouselHeight from '@/utils/mobileCarouselHeight'

export default {
  mixins: [mobileCarouselHeight],
  props: {
    bannerHeight: {
      require: true
    }
  },
  data() {
    return {
      mobileSlideHeight: 480,
      activeInd: 0,
      btn1,
      btn2,
      carouselList: [
        {
          icon: al1,
          num: '01',
          name: '产品管理：全生命周期整合',
          description: '产品管理模块主要有以下特点：',
          contentList: [
            {
              content: '从需求、实验、中试、批量到常态化维护，各阶段技术活动全覆盖，产品全生命周期信息整合，经验得以有序沉淀'
            },
            {
              content: '实验、量产等阶段流转跟踪追溯清晰、明确，数据可控且互通，有效避免业务脱节或衔接缺漏，降低质量风险'
            }
          ]
        },
        {
          icon: al2,
          num: '02',
          name: '配方管理：结构化',
          description: '配方管理模块主要有以下特点：',
          contentList: [
            {
              content: '结构化配方搭建模式，可支撑多样式生产制造作业'
            },
            {
              content: '支持研发视图、生产视图等多样式呈现，配方结构可分层导出，可自定义扩大倍数，以适配不同使用场景'
            },
            {
              content: '系统计算配方总量、原料占比、材料成本，以准确快速把控配方设计性价比'
            }
          ]
        },
        {
          icon: al3,
          num: '03',
          name: '工艺管理：标准化',
          description: '工艺管理模块主要有以下特点：',
          contentList: [
            {
              content: '基于自定义模板，可批量快速创建规范化、结构化、数据化的工艺文件，满足产品制造单工序、多工序生产模式'
            },
            {
              content: '支持表格、图片、文字等多样式呈现工艺卡、SOP等，给予生产制造过程简洁明了、直观清晰的指导'
            }
          ]
        },
        {
          icon: al4,
          num: '04',
          name: '实验管理：全面资源管理',
          description: '实验管理模块主要有以下特点：',
          contentList: [
            {
              content: '可在实验流程中批量维护实验配方、工艺、测评数据，实现人机料法环全面资源管理，成功、失败经验全纪录'
            },
            {
              content: '提供实验设备、人力资源看板以预约、协调档期，有效避免资源使用冲突，减少资源调度耗时'
            },
            {
              content: '系统自动生成规范的实验报告、检验报告'
            },
            {
              content: '研发物料库存根据实验自动扣减，保障账物一致性'
            }
          ]
        },
        {
          icon: al5,
          num: '05',
          name: '检测管理：质控闭环',
          description: '检测管理模块主要有以下特点：',
          contentList: [
            {
              content: '与实验打样、中试等活动联通，支持检测指标下达、实测结果记录、分析判定、检验报告输出、审核流转等的闭环管理'
            },
            {
              content: '支持数值、文本、照片、视频等各类型检测数据存储分析，自动生成指定样式检验报告'
            }
          ]
        },
        {
          icon: al6,
          num: '06',
          name: '成本管理：计算、分析与预测',
          description: '成本管理模块主要有以下特点：',
          contentList: [
            {
              content: '基于权限，可查阅物料与配方在指定历史时间周期内的价格数据详情与走势图、对比图，为产品配方优化、原料选型提供直观指导'
            },
            {
              content: '可虚拟调整某原料的价格，预测受该原料价格波动影响的所有配方材料成本变化情况，为原料备库策略、产品市场报价提供指导，降低因原料价格大幅震荡波动、信息时间差所带来的采销风险'
            }
          ]
        },
        {
          icon: al7,
          num: '07',
          name: '知识管理：经验可视化',
          description: '知识管理模块主要有以下特点：',
          contentList: [
            {
              content: '可根据市场新需求，基于物性要求或原料占比检索系统中适配的配方，充分利用已沉淀的经验，避免同类产品重复开发，节约研发成本'
            },
            {
              content: '为检索结果提供雷达图、组合图等多种可视化图表，助力快速优选性价比最优、最贴合需求的配方'
            }
          ]
        },
        {
          icon: al8,
          num: '08',
          name: '合规管理：合规指引与管控',
          description: '合规管理模块主要有以下特点：',
          contentList: [
            {
              content: '支持行业法规、国标、行标、团标等外来规范性文件的可视化管理、正反查询，指引设计、生产与检测等活动的规范性'
            },
            {
              content: '提供结构化的企标、检验规范、作业指导书、SDS等内部规范性文件模型，助力在线监测、预警与判定'
            }
          ]
        },
      ]
    }
  },
  created() {
  },
  computed: {
    previewImgs() {
      return this.carouselList.map(item => item.icon).filter(Boolean)
    }
  },
  methods: {
    setActiveItem(val) {
      this.activeInd = val
    },
    clickHandle(val) {
      const newInd = this.activeInd + val
      if(newInd === -1) {
        this.$refs.carousel.setActiveItem(this.carouselList.length - 1)
      } else if(newInd === this.carouselList.length) {
        this.$refs.carousel.setActiveItem(0)
      } else {
        this.$refs.carousel.setActiveItem(newInd)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
$img: "../../assets/images";

.key-advantages {
  padding: 10rem 26rem 8.9rem;
  flex-direction: column;
  align-items: center;
  background: linear-gradient(168deg, #FBFCFD 0%, #F4F7F9 100%);

  .title {
    font-size: 4rem;
    font-weight: 600;
    color: #333333;
    line-height: 4rem;
    margin-bottom: 2.4rem;
  }

  .description {
    font-size: 1.8rem;
    font-weight: 400;
    color: #666A77;
    line-height: 1.8rem;
    margin-bottom: 5rem;
  }

  .ClassicCase-content {
    width: 100%;
    background: #FFFFFF;
    padding: 5.4rem;
    .carousel-box {
      width: 100%;
      height: 100%;
      .content-left {
        width: 70rem;
        height: 45rem;
        .case-img {
          width: 100%;
          height: 100%;
          object-fit: contain;
          object-position: center;
          cursor: zoom-in;
        }
        ::v-deep .preview-shot {
          display: block;
          .el-image__inner {
            width: 100%;
            height: 100%;
            object-fit: contain;
            object-position: center;
          }
        }
      }
      .content-right {
        margin-left: 7.3rem;
        margin-top: 2.5rem;
        width: 51rem;
        height: 33rem;
        position: relative;

        .info-wrap {
          height: 27.5rem;
        }
        .content-num {
          font-family: DINAlternate, DINAlternate;
          font-weight: bold;
          font-size: 7.2rem;
          color: #3674FE;
          line-height: 7.2rem;
          text-align: left;
          font-style: normal;
          opacity: .1;
          position: absolute;
          left: 0;
          top: 0;
        }
        .content-name {
          font-size: 3.2rem;
          font-weight: 600;
          color: #333333;
          line-height: 3.6rem;
          padding: 3.6rem 0 2.4rem;
          border-bottom: 0.1rem solid rgba(54, 116, 254, .21);
        }

        .content-desc {
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 2rem;
          color: #333333;
          line-height: 2rem;
          text-align: left;
          font-style: normal;
          padding: 2.4rem 0 2.6rem;
        }

        .cl-list {
          width: 47rem;
          .cl-list-item {
            margin-bottom: 2.4rem;
            .cl-l-i-content {
              padding-left: 2rem;
              position: relative;
              font-weight: 400;
              font-size: 1.6rem;
              color: #666A77;
              line-height: 2.4rem;
              text-align: left;
              font-style: normal;
              &::before {
                position: absolute;
                left: 0;
                top: .5rem;
                content: '';
                width: 1rem;
                height: 1rem;
                border: 0.2rem solid #3674FE;
                display: inline-block;
                border-radius: 50%;
              }
            }
          }
        }
      }
    }
  }

  .btn-wrap {
    margin-top: 4.8rem;
    img {
      width: 5.4rem;
      height: 5.4rem;
      border-radius: 50%;
      cursor: pointer;
      margin: 0 1.5rem;
      // box-shadow: 0rem 1.3rem 1.5rem 0rem rgba(255,204,196,0.6);
      box-shadow: 0rem 1.3rem 1.5rem 0rem rgba(169,169,169,0.2);
    }
    .img1 {
      box-shadow: 0rem 1.3rem 1.5rem 0rem rgba(169,169,169,0.2);
    }
    .img2 {
      box-shadow: 0rem 1.3rem 1.5rem 0rem rgba(255,204,196,0.6);
    }
  }
}

@import "@/styles/mixins.scss";

@include mobile {
  .key-advantages {
    padding: 3.2rem 1.6rem 2.4rem;
    .title {
      font-size: 2.4rem;
      line-height: 3.2rem;
      text-align: center;
    }
    .description {
      font-size: 1.4rem;
      line-height: 2.2rem;
      text-align: center;
      margin-bottom: 1.6rem;
    }
    .ClassicCase-content {
      padding: 1.6rem;
      .carousel-box {
        height: auto;
        min-height: 0;
        flex-direction: column;
        flex-wrap: nowrap;
        justify-content: center;
        align-content: center;
        .content-left,
        .content-right {
          width: 100%;
          height: auto;
          margin: 0 0 1.6rem;
          overflow: visible;
        }
        .content-left {
          margin-bottom: 1.2rem;
          .case-img {
            height: auto;
            max-height: 16rem;
            object-fit: contain;
          }
          ::v-deep .preview-shot .el-image__inner {
            height: auto;
            max-height: 16rem;
            object-fit: contain;
          }
        }
        .content-right {
          margin-top: 0;
          margin-bottom: 0;
          .info-wrap,
          .content-name,
          .content-desc,
          .cl-list {
            width: 100%;
            height: auto;
            white-space: normal;
            word-break: break-word;
          }
          .content-num {
            font-size: 4.8rem;
            line-height: 4.8rem;
          }
          .content-name {
            font-size: 2rem;
            line-height: 2.8rem;
            padding: 2.4rem 0 1.2rem;
          }
          .content-desc {
            font-size: 1.4rem;
            line-height: 2.2rem;
            padding: 1.2rem 0 1.6rem;
          }
          .cl-list-item {
            margin-bottom: 1.2rem;
            .cl-l-i-content {
              font-size: 1.4rem;
              line-height: 2.2rem;
            }
          }
        }
      }
    }
    .btn-wrap {
      margin-top: 2rem;
    }
  }
}
</style>
